module.exports = __webpack_public_path__ + "img/battery.a97f5aa7.svg";